module.exports = {
  syncSources: {
    appointment_types: 'appointment_types',
  },
};
